import BinIcon from "@/components/icons/BinIcon.tsx";
import CrossIcon from "@/components/icons/CrossIcon.tsx";
import CheckIcon from "@/components/icons/CheckIcon.tsx";
import UncheckIcon from "@/components/icons/UncheckIcon.tsx";

interface GetEventIconProps {
  present: boolean;
  past: boolean;
  deleted?: boolean;
}

const GetIcon = ({ present, past, deleted }: GetEventIconProps) => {
  if (past) {
    if (present)
      return <CheckIcon className={"fill-brand-dark-green w-2 h-2"} />;
    if (deleted) return <BinIcon className={"fill-red-700 w-2 h-2"} />;
    return <CrossIcon className={"fill-red-700 w-2 h-2"} />;
  }
  return <UncheckIcon className={"w-2 h-2 text-inherit"} />;
};

export default GetIcon;
